import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/networks/$networkId/details')({
  component: Outlet,
});
